let playerOverlay;
let isPlayerBaseEnded = false;
let isPlayerOverlayEnded = false;

function createOverlayVideoElement(src) {
    const layout = `<video id='videoPlayerOverlay' class='video-js video-js-overlay js-video-player-overlay' playsinline>
        <source src='${src}' type='video/mp4'>
    </video>`;

    $('.js-video-player-wrapper').prepend(layout);
}

function adjustPlayerWithOverlay(src, index) {
    if (isOverlayed) {
        createOverlayVideoElement(src);

        playerOverlay = $('#videoPlayerOverlay').get(0);

        playerOverlay.addEventListener('ended', function () {
            isPlayerOverlayEnded = true;

            if (isPlayerOverlayEnded && isPlayerBaseEnded) {
                startCountdown();
            }
        });
    }

    $(document).on('watchAgainOverlayEvent', function () {
        isPlayerBaseEnded = false;
        isPlayerOverlayEnded = false;

        playerOverlay.load();
        playerOverlay.currentTime = 0;
        playerOverlay.play();
    });
}

function adjustSegments(array1, array2, player1, player2) {
    // Ensure arrays have the same length
    const maxLength = Math.max(array1.length, array2.length);

    const array1SegmentTime = convertToMilliseconds(array1);
    const array2SegmentTime = convertToMilliseconds(array2);
    const player1CurrentTime = convertToMilliseconds([
        Number(player1.currentTime().toFixed(3)),
    ])[0];
    const player2CurrentTime = convertToMilliseconds([
        Number(player2.currentTime.toFixed(3)),
    ])[0];

    for (let i = 0; i < maxLength; i++) {
        if (
            player1CurrentTime >= array1SegmentTime[i] &&
            player2CurrentTime < array2SegmentTime[i]
        ) {
            player2.currentTime = array2[i];
        }
        if (
            player2CurrentTime >= array2SegmentTime[i] &&
            player1CurrentTime < array1SegmentTime[i]
        ) {
            player1.currentTime(array1[i]);
        }
    }
}
